import dashboard from './DashboardStore';
import patient from './PatientStore';
import setting from './SettingStore';
import event from './EventStore';
import device from './DeviceStore';
import deviceType from './DeviceTypeStore';
import router from './RouterStore';
import routerType from './RouterTypeStore';
import logActivity from './LogActivityStore';
import group from './GroupStore';
import locations from './LocationsStore';
import subGroup from './SubGroupStore';
import upload from './UploadStore';
import maps from './MapStore';
import bed from './BedStore';
import fcm from './FcmStore';
import user from './UserStore';
import role from './RoleStore';
import screen from './ScreenStore';
import qrcode from './QrCodeStore';
import acknowledge from './AcknowledgeStore';
import settingProfile from './SettingProfileStore';
import area from './AreaStore';
import summary from './SummaryReportStore';
import vitalsign from './VitalSignStore';
import devicePermission from './DevicePermissionStore';
import contactperson from './ContactPersonStore';
import smartwatch from './SmartwatchStore';
import smartwatchsummary from './SmartwatchSummaryStore';
import garmin from './GarminStore';
import tenant from './TenantStore';
import nirun from './NirunStore';
import wizard from './WizardStore';
import usageSummary from './UsageSummaryStore';
import patientsummaryalert from './PatientSummaryAlertStore';

export default {
  dashboard,
  patient,
  setting,
  event,
  device,
  deviceType,
  router,
  routerType,
  logActivity,
  group,
  locations,
  subGroup,
  upload,
  maps,
  bed,
  fcm,
  user,
  role,
  screen,
  qrcode,
  acknowledge,
  settingProfile,
  area,
  summary,
  vitalsign,
  devicePermission,
  contactperson,
  smartwatch,
  smartwatchsummary,
  garmin,
  tenant,
  nirun,
  wizard,
  usageSummary,
  patientsummaryalert,
};
